/* EP Runde 14: ausgelagert aus snippets/ep-qv-variant-select.liquid. defer. */
(function () {
  'use strict';

  var SIZE_RE = /(\d+[.,]?\d*)\s*(g|kg|ml|l|kaps|kapseln|caps|st(ue|ü)ck|portion)/i;
  var OUT_RE = /\s*[-–]\s*ausverkauft\s*$/i;
  var VSEL = 'select[data-js-product-variant-container="select"], select.product-variant-container';
  var CHEVRON = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var nf = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var obs = null, timer = null, open = null, lastSig = '', vNode = null, vCache = null, preNode = null;

  function money(c) { return nf.format((c || 0) / 100); }
  function clean(t) { return (t || '').replace(OUT_RE, '').trim(); }
  function isOut(o) { return o.getAttribute('data-sold-out') === 'true'; }
  function isPh(o) { return o.disabled || o.value === ''; }

  function qv() {
    var mods = document.querySelectorAll('.modal--product');
    var withPV = [];
    for (var i = 0; i < mods.length; i++) { if (mods[i].querySelector('product-variants')) withPV.push(mods[i]); }
    if (!withPV.length) return null;
    for (var j = withPV.length - 1; j >= 0; j--) { if (withPV[j].classList.contains('active')) return withPV[j]; }
    return withPV[withPV.length - 1];
  }
  function root() { var s = qv(); if (!s) return null; return s.querySelector('product-variants[data-has-variants]') || s.querySelector('product-variants'); }

  /* EP: Radio-Gruppe als "virtuelles Select" – gleiche Schnittstelle wie ein <select>, damit der Rest des Moduls unverändert arbeitet */
  function radioAdapter(block) {
    var inputs = Array.prototype.slice.call(block.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return null;
    var old = block.__epvAd;
    if (old && old._inputs.length === inputs.length && old._inputs[0] === inputs[0]) return old;

    var container = block.querySelector('.product-variant-container');
    var hideTargets = [];
    if (container && container !== block) { hideTargets.push(container); }
    else {
      inputs.forEach(function (inp) {
        hideTargets.push(inp);
        var lab = inp.id ? block.querySelector('label[for="' + inp.id + '"]') : null;
        if (!lab && inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL') lab = inp.nextElementSibling;
        if (lab) hideTargets.push(lab);
      });
    }

    function labelFor(inp) {
      var lab = inp.id ? block.querySelector('label[for="' + inp.id + '"]') : null;
      if (!lab && inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL') lab = inp.nextElementSibling;
      if (!lab && inp.parentElement && inp.parentElement.tagName === 'LABEL') lab = inp.parentElement;
      return lab;
    }

    var ad = {
      isRadio: true,
      _inputs: inputs,
      parentElement: block,
      options: inputs.map(function (inp) {
        var lab = labelFor(inp);
        var txt = lab ? lab.textContent : inp.value;
        var so = inp.getAttribute('data-sold-out') === 'true'
          || (lab && lab.getAttribute('data-sold-out') === 'true')
          || inp.classList.contains('sold-out') || inp.classList.contains('is-sold-out')
          || (lab && (lab.classList.contains('sold-out') || lab.classList.contains('is-sold-out')))
          || /ausverkauft|sold out/i.test(txt || '');
        return {
          textContent: txt || '', value: inp.value, disabled: false,
          getAttribute: function (a) { return a === 'data-sold-out' ? (so ? 'true' : 'false') : inp.getAttribute(a); }
        };
      }),
      classList: {
        add: function (c) { hideTargets.forEach(function (el) { el.classList.add(c); }); },
        remove: function (c) { hideTargets.forEach(function (el) { el.classList.remove(c); }); }
      },
      setAttribute: function () {},
      get selectedIndex() { for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return i; return -1; },
      set selectedIndex(i) { if (inputs[i]) inputs[i].checked = true; },
      dispatchEvent: function (ev) { var i = this.selectedIndex; if (inputs[i]) inputs[i].dispatchEvent(new Event(ev.type, { bubbles: true })); }
    };
    block.__epvAd = ad;
    return ad;
  }

  /* EP: alle Options-Picker des Modals in DOM-Reihenfolge – <select> oder Radio-Gruppe */
  function selects() {
    var s = qv(); if (!s) return [];
    var r = root(); if (!r) return [];
    var out = [];
    var blocks = r.querySelectorAll('[data-js-product-variant], .product-variant');
    var seen = [];
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var skip = false;
      for (var k = 0; k < seen.length; k++) { if (seen[k].contains(b) && seen[k] !== b) { skip = true; break; } }
      if (skip) continue;
      var sel = b.querySelector(VSEL);
      if (sel) { out.push(sel); seen.push(b); continue; }
      var ad = radioAdapter(b);
      if (ad) { out.push(ad); seen.push(b); }
    }
    if (!out.length) out = Array.prototype.slice.call(r.querySelectorAll(VSEL));
    return out;
  }

  function loadVariants() {
    var r = root(); if (!r) return null;
    var n = r.querySelector('script[type="application/json"]'); if (!n) return null;
    if (n === vNode && vCache) return vCache;
    try { vCache = JSON.parse(n.textContent); vNode = n; } catch (e) { vCache = null; }
    return vCache;
  }

  function optPos(sel) { return selects().indexOf(sel); }

  function chosen() {
    var list = selects(); var vals = [];
    for (var i = 0; i < list.length; i++) vals.push(null);
    list.forEach(function (s) { var o = s.options[s.selectedIndex]; if (!o || isPh(o)) return; var p = optPos(s); if (p >= 0) vals[p] = clean(o.textContent); });
    return vals;
  }

  function findVariant(vals) {
    var lst = loadVariants(); if (!lst) return null;
    for (var i = 0; i < lst.length; i++) { var v = lst[i], ok = true; for (var k = 0; k < vals.length; k++) { if (vals[k] === null) continue; if (String(v.options[k]) !== String(vals[k])) { ok = false; break; } } if (ok) return v; }
    return null;
  }
  function currentVariant() { return findVariant(chosen()); }
  function variantFor(sel, label) { var vals = chosen(); var p = optPos(sel); if (p >= 0) vals[p] = label; return findVariant(vals); }
  function optionAvailable(sel, label, fb) { var v = variantFor(sel, label); if (v) return !!v.available; return !fb; }

  function fallbackImg() { var s = qv(); if (!s) return ''; var im = s.querySelector('.product-gallery img, .product-gallery-item img'); return im ? (im.currentSrc || im.src || '') : ''; }
  function variantImg(v) {
    if (v) {
      if (v.featured_image && v.featured_image.src) return v.featured_image.src;
      if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) return v.featured_media.preview_image.src;
      if (typeof v.featured_image === 'string' && v.featured_image) return v.featured_image;
    }
    return fallbackImg();
  }
  function withW(src) {
    if (!src) return '';
    if (/[?&]width=/.test(src)) return src;
    if (src.indexOf('/cdn/shop') === -1 && src.indexOf('cdn.shopify') === -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=144';
  }

  function preselect() {
    var r = root(); if (!r) return;
    if (preNode === r) return; preNode = r;
    var lst = loadVariants(); if (!lst || !selects().length) return;
    var cur = currentVariant(); if (cur && cur.available) return;
    var target = null; for (var i = 0; i < lst.length; i++) if (lst[i].available) { target = lst[i]; break; }
    if (!target) return;
    selects().forEach(function (s) {
      var p = optPos(s); if (p < 0) return; var want = String(target.options[p]);
      for (var j = 0; j < s.options.length; j++) { if (isPh(s.options[j])) continue; if (clean(s.options[j].textContent) === want) { s.selectedIndex = j; break; } }
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
    setTimeout(renderAll, 80);
  }

  function isSizeSelect(sel) { var hits = 0, total = 0; for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i]; if (isPh(o)) continue; total++; if (SIZE_RE.test(clean(o.textContent))) hits++; } return total > 0 && hits / total >= 0.6; }
  function hasSizeSelect() { var l = selects(); for (var i = 0; i < l.length; i++) if (isSizeSelect(l[i])) return true; return false; }
  function grams(label) { var m = SIZE_RE.exec(label); if (!m) return 0; var n = parseFloat(String(m[1]).replace(',', '.')); var u = m[2].toLowerCase(); if (u === 'kg' || u === 'l') return n * 1000; return n; }

  function pick(sel, index) { if (index < 0 || index >= sel.options.length) return; if (isPh(sel.options[index])) return; sel.selectedIndex = index; sel.dispatchEvent(new Event('input', { bubbles: true })); sel.dispatchEvent(new Event('change', { bubbles: true })); lastSig = ''; setTimeout(renderAll, 40); }

  function makeCard(opts) {
    var b = document.createElement(opts.button ? 'button' : 'div');
    if (opts.button) b.type = 'button';
    b.className = 'ep-size' + (opts.active ? ' is-active' : '') + (opts.out ? ' is-out' : '') + (opts.button ? '' : ' ep-size--static');
    if (opts.epi != null) b.setAttribute('data-epi', String(opts.epi));
    if (opts.img) { var im = document.createElement('img'); im.className = 'ep-size__img'; im.src = opts.img; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
    var n1 = document.createElement('span'); n1.className = 'ep-size__name'; n1.textContent = opts.name; b.appendChild(n1);
    if (opts.price != null) {
      var p1 = document.createElement('span'); p1.className = 'ep-size__price'; p1.textContent = money(opts.price);
      if (opts.compare && opts.compare > opts.price) { var oldEl = document.createElement('span'); oldEl.className = 'ep-size__old'; oldEl.textContent = money(opts.compare); p1.appendChild(document.createTextNode(' ')); p1.appendChild(oldEl); }
      b.appendChild(p1);
    }
    if (opts.out) { var f1 = document.createElement('span'); f1.className = 'ep-size__flag'; f1.textContent = 'Ausverkauft'; b.appendChild(f1); }
    return b;
  }

  function buildSizes(sel, host) {
    var rows = [];
    for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i]; if (isPh(o)) continue; var label = clean(o.textContent); rows.push({ i: i, label: label, g: grams(label), out: isOut(o) }); }
    rows.sort(function (a, b) { return a.g - b.g; });

    var wrap = document.createElement('div'); wrap.className = 'ep-sizes';
    rows.forEach(function (r) {
      var v = variantFor(sel, r.label);
      var cents = v ? v.price : null;
      var comp = v ? v.compare_at_price : null;
      wrap.appendChild(makeCard({ button: true, epi: r.i, active: r.i === sel.selectedIndex, out: r.out, img: withW(variantImg(v)), name: r.label, price: cents !== null ? cents : null, compare: comp }));
    });

    wrap.addEventListener('click', function (e) { var b = e.target.closest ? e.target.closest('.ep-size') : null; if (b && b.hasAttribute('data-epi')) pick(sel, parseInt(b.getAttribute('data-epi'), 10)); });

    var scroller = document.createElement('div'); scroller.className = 'ep-sizes-wrap'; scroller.appendChild(wrap); host.appendChild(scroller);

    function syncEnd() { var end = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2; scroller.classList.toggle('is-end', end); }
    wrap.addEventListener('scroll', syncEnd, { passive: true });
    requestAnimationFrame(function () { try { if (wrap.scrollWidth > wrap.clientWidth + 2) { scroller.classList.add('is-scrollable'); syncEnd(); } } catch (e) {} });
  }

  function buildSingleSize() {
    var pv = root(); if (!pv) return;
    if (pv.querySelector('.ep-single-size')) return;
    var lst = loadVariants(); var v = (lst && lst.length) ? lst[0] : null;
    var cur = currentVariant(); if (cur) v = cur;
    var price = v ? v.price : null; var comp = v ? v.compare_at_price : null; var img = withW(variantImg(v));
    var titleEl = qv() ? qv().querySelector('.product__title') : null;
    var t = titleEl ? titleEl.textContent.trim() : '';
    var m = SIZE_RE.exec(t || ''); var name = m ? clean(m[0]) : 'Einheitsgröße';

    var host = document.createElement('div'); host.className = 'ep-ui ep-single-size';
    var h = document.createElement('div'); h.className = 'ep-label'; var s = document.createElement('span'); s.textContent = 'Größe'; h.appendChild(s); host.appendChild(h);
    var scroller = document.createElement('div'); scroller.className = 'ep-sizes-wrap'; var wrap = document.createElement('div'); wrap.className = 'ep-sizes';
    wrap.appendChild(makeCard({ button: false, active: true, img: img, name: name, price: price || null, compare: comp }));
    scroller.appendChild(wrap); host.appendChild(scroller);

    var anchor = pv.querySelector('.product-variants--select') || pv.querySelector('.product-variants--radio');
    if (anchor && anchor.parentNode === pv) pv.insertBefore(host, anchor.nextSibling); else pv.insertBefore(host, pv.firstChild);
  }

  function closeList(sel) { var r = sel && sel.epvRef; if (!r) return; r.list.hidden = true; r.btn.setAttribute('aria-expanded', 'false'); if (open === sel) open = null; }
  function showList(sel) { if (open && open !== sel) closeList(open); var r = sel.epvRef; r.list.hidden = false; r.btn.setAttribute('aria-expanded', 'true'); open = sel; var a = r.list.querySelector('[aria-selected="true"]'); if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' }); }

  function buildDropdown(sel, host, name) {
    var rows = [], inN = 0, allN = 0;
    for (var j = 0; j < sel.options.length; j++) { var o2 = sel.options[j]; if (isPh(o2)) continue; var lab = clean(o2.textContent); var avail = optionAvailable(sel, lab, isOut(o2)); allN++; if (avail) inN++; rows.push({ i: j, label: lab, out: !avail }); }
    rows.sort(function (a, b) { return (a.out ? 1 : 0) - (b.out ? 1 : 0) || a.i - b.i; });

    var displayName = (!name || name.toLowerCase() === 'geschmack') ? 'Wähle deinen Geschmack' : name;

    var head = document.createElement('div'); head.className = 'ep-label';
    var l1 = document.createElement('span'); l1.textContent = displayName;
    var c1 = document.createElement('span'); c1.className = 'ep-label__count'; c1.textContent = inN + ' von ' + allN + ' verfügbar';
    head.appendChild(l1); head.appendChild(c1); host.appendChild(head);

    var shell = document.createElement('div'); shell.style.position = 'relative'; shell.style.marginBottom = '22px'; host.appendChild(shell);

    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'epv-btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="epv-btn__label"><span class="epv-dot"></span><span class="epv-btn__text"></span></span><span class="epv-btn__icon">' + CHEVRON + '</span>';

    var list = document.createElement('div'); list.className = 'epv-list'; list.setAttribute('role', 'listbox'); list.hidden = true;
    shell.appendChild(btn); shell.appendChild(list); sel.epvRef = { btn: btn, list: list };

    rows.forEach(function (r) {
      var it = document.createElement('div'); it.className = 'epv-item ' + (r.out ? 'is-out' : 'is-in'); it.setAttribute('role', 'option'); it.setAttribute('data-epi', String(r.i)); it.setAttribute('aria-selected', r.i === sel.selectedIndex ? 'true' : 'false');
      var d = document.createElement('span'); d.className = 'epv-dot'; var t = document.createElement('span'); t.className = 'epv-item__text'; t.textContent = r.label; it.appendChild(d); it.appendChild(t);
      if (r.out) { var f = document.createElement('span'); f.className = 'epv-flag'; f.textContent = 'Ausverkauft'; it.appendChild(f); }
      list.appendChild(it);
    });

    var cur = sel.options[sel.selectedIndex]; btn.classList.remove('is-in');
    if (cur && !isPh(cur)) { var curLabel = clean(cur.textContent); btn.querySelector('.epv-btn__text').textContent = curLabel; if (optionAvailable(sel, curLabel, isOut(cur))) btn.classList.add('is-in'); }
    else { btn.querySelector('.epv-btn__text').textContent = 'Bitte wählen'; }

    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (list.hidden) showList(sel); else closeList(sel); });
    list.addEventListener('click', function (e) { var it = e.target.closest ? e.target.closest('.epv-item') : null; if (!it) return; e.preventDefault(); e.stopPropagation(); closeList(sel); pick(sel, parseInt(it.getAttribute('data-epi'), 10)); });
  }

  function blockOf(sel) { return sel.isRadio ? sel.parentElement : (sel.closest ? sel.closest('[data-js-product-variant], .product-variant') : null); }

  function orderVisual() {
    var list = selects(); if (list.length < 2) return;
    var sizeSel = null; for (var i = 0; i < list.length; i++) if (isSizeSelect(list[i])) { sizeSel = list[i]; break; }
    if (!sizeSel) return;
    var block = blockOf(sizeSel); if (!block || !block.parentNode) return;
    var container = block.parentNode; container.style.display = 'flex'; container.style.flexDirection = 'column';
    var blocks = container.querySelectorAll('[data-js-product-variant], .product-variant');
    for (var k = 0; k < blocks.length; k++) blocks[k].style.order = '0';
    block.style.order = '1';
  }

  function currentSig() { var r = root(); var id = r ? (r.getAttribute('data-id') || r.id || '') : ''; return id + '::' + selects().map(function (s) { return s.selectedIndex; }).join('|') + '#' + selects().length; }

  function renderPickers() {
    var sig = currentSig();
    var s = qv();
    if (s && s.querySelector('.ep-ui') && sig === lastSig) return;
    lastSig = sig;

    selects().forEach(function (sel) {
      var host = sel.parentElement; if (!host) return;
      host.classList.add('epv-host'); sel.classList.add('epv-native'); sel.setAttribute('tabindex', '-1'); sel.setAttribute('aria-hidden', 'true');
      var old = host.querySelector('.ep-ui'); if (old) old.remove();
      var lbl = host.querySelector('.product-variant__name'); var name = lbl ? lbl.textContent.trim() : ''; if (lbl) lbl.style.display = 'none';
      var ui = document.createElement('div'); ui.className = 'ep-ui'; host.appendChild(ui);
      if (isSizeSelect(sel)) {
        var h = document.createElement('div'); h.className = 'ep-label'; var sp = document.createElement('span'); sp.textContent = name || 'Größe'; h.appendChild(sp); ui.appendChild(h);
        buildSizes(sel, ui);
      } else { buildDropdown(sel, ui, name); }
    });

    if (!hasSizeSelect()) { var old1 = root() ? root().querySelector('.ep-single-size') : null; if (old1) old1.remove(); buildSingleSize(); }
  }

  function revealNative() { try { var s = qv(); if (!s) return; Array.prototype.forEach.call(s.querySelectorAll('.epv-native'), function (el) { el.classList.remove('epv-native'); el.style.cssText = 'position:static!important;width:auto!important;height:auto!important;opacity:1!important;clip:auto!important;pointer-events:auto!important;'; }); } catch (e) {} }

  function renderAll() {
    if (open) return;
    if (!qv() || !root()) { preNode = null; lastSig = ''; return; }
    if (obs) obs.disconnect();
    try { orderVisual(); preselect(); renderPickers(); } catch (e) { revealNative(); }
    if (obs) obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) { if (!open) return; var r = open.epvRef; if (r && (r.btn.contains(e.target) || r.list.contains(e.target))) return; closeList(open); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) closeList(open); });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.closest('.modal--product')) return;
    if (t.tagName === 'SELECT' || (t.tagName === 'INPUT' && t.type === 'radio')) { lastSig = ''; setTimeout(renderAll, 40); }
  }, true);

  function start() {
    obs = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(renderAll, 140); });
    obs.observe(document.body, { childList: true, subtree: true });
    renderAll();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
